import { Textarea as HeroTextarea, TextAreaProps as HeroTextareaProps } from '@heroui/react'

const Textarea = ({
  variant = 'bordered',
  classNames,
  labelPlacement = 'outside',
  name,
  isRequired = false,
  value,
  onChange,
  onBlur,
  errorMessage,
  ...props
}: HeroTextareaProps) => {
  // For form context, don't use controlled value unless explicitly provided
  const textareaProps: any = {
    fullWidth: true,
    isRequired,
    name,
    variant,
    labelPlacement,
    errorMessage,
    radius: 'sm',
    classNames: {
      label: [
        'text-gray-900',
        'dark:text-foreground',
        'group-data-[filled-within=true]:text-gray-900',
        'dark:group-data-[filled-within=true]:text-white',
        'group-data-[invalid=true]:text-danger',
        'dark:group-data-[invalid=true]:text-danger',
        ...(classNames?.label || []),
      ],
      input: [
        'bg-transparent',
        'text-gray-900',
        'dark:text-white',
        'placeholder:text-gray-500',
        'dark:placeholder:text-white/60',
        'group-data-[invalid=true]:placeholder:text-danger',
        ...(classNames?.input || []),
      ],
      innerWrapper: 'bg-transparent',
      inputWrapper: [
        'bg-gray-50',
        'dark:bg-[#1e1e20]',
        'border-gray-200',
        'dark:border-default-600',
        'hover:bg-gray-100',
        'dark:hover:bg-[#1e1e20]/70',
        'group-data-[focus=true]:bg-gray-100',
        'dark:group-data-[focus=true]:bg-[#1e1e20]/50',
        'group-data-[focus=true]:border-primary',
        'dark:group-data-[focus=true]:border-primary',
        '!cursor-text',
        ...(classNames?.inputWrapper || []),
      ],
    },
    onBlur,
    ...props,
  }

  // Only add controlled props if value and onChange are provided
  if (value !== undefined && onChange) {
    textareaProps.value = value
    textareaProps.onValueChange = onChange
  }

  return <HeroTextarea {...textareaProps} />
}

export default Textarea
